"use strict";
(function() {
    var errorCallback = window.onerror;

    function recordError(error) {
        $.ajax({
            type: "POST",
            url: $("#javascript-error-report").attr(
                "data-javascript-error-report-url"
            ),
            data: { error: error }
        });
    }

    window.onerror = function(msg, url, lineNo, columnNo, error) {
        try {
            // callback is called with an Array[StackFrame]
            StackTrace.fromError(error)
                .then(function(frames) {
                    var joined = frames.join("\n");
                    recordError(
                        "Javascript error on " +
                            url +
                            " at line " +
                            lineNo +
                            " " +
                            error +
                            "\n\n" +
                            joined
                    );
                })
                .catch(function() {
                    recordError(
                        "Javascript error on " +
                            url +
                            " at line " +
                            lineNo +
                            " " +
                            error
                    );
                });
        } catch (ex) {}
        errorCallback && errorCallback.apply(this, arguments);
        return false;
    };
})();
